namespace TabAurous.Inventory {
    export namespace BranchInSelectItemsService {
        export const baseUrl = 'Inventory/BranchInSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<BranchInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Inventory/BranchInSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>BranchInSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
